module.exports = __webpack_public_path__ + "static/img/null.676d5b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/null.png
// module id = TI6G
// module chunks = 1